import { httpClient } from '~/http/client'

import { adaptRemoteStorageValues } from './adapters'
import type { RemoteStorageValues } from './schemas'

/** 사용자 설정을 읽는 주체. 선생님·학생·학부모의 relation id 다 */
export type RemoteStorageOwnerId = string

/** 키들의 값을 읽는다. 저장된 적 없는 키는 결과에 없다 */
export const getRemoteStorageValues = async (
  ownerId: RemoteStorageOwnerId,
  keys: string[],
): Promise<RemoteStorageValues> =>
  adaptRemoteStorageValues(
    await httpClient('remoteStorage').get<unknown>(`/storage/${ownerId}`, {
      params: { keys: keys.join(',') },
    }),
  )

/** 넘긴 키만 덮어쓴다. 값을 null 로 보내면 그 키를 지운다 */
export const updateRemoteStorageValues = async (
  ownerId: RemoteStorageOwnerId,
  values: RemoteStorageValues,
): Promise<void> => {
  await httpClient('remoteStorage').patch<unknown>(`/storage/${ownerId}`, values)
}
